import styled from 'styled-components'
import { colors, getFontStyle } from '@diversioteam/diversio-ds'

export const ProfileButton = styled.button`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px;
    border-radius: 9999px;
    background: transparent;
    border: none;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: ${colors.primaryGray1};
    }

    &:focus {
        outline: none;
    }
`

export const AvatarContainer = styled.div`
    width: 40px;
    height: 40px;
    border-radius: 9999px;
    overflow: hidden;
    background-color: ${colors.primaryGray2};
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const AvatarImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`

export const AvatarFallback = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${colors.primary60};
    color: ${colors.primaryWhite};
    ${getFontStyle('p02Semibold')}
`

export const DropdownHeader = styled.div`
    padding: 12px 16px;
    border-bottom: 1px solid ${colors.primaryGray1};
`

export const ProfileInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
`

export const LargeAvatarContainer = styled.div`
    width: 48px;
    height: 48px;
    border-radius: 9999px;
    overflow: hidden;
    background-color: ${colors.primaryGray2};
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
`

export const UserDetails = styled.div`
    display: flex;
    flex-direction: column;
`

export const UserName = styled.span`
    ${getFontStyle('p02Semibold')}
    color: ${colors.primary90};
`

export const UserRole = styled.span`
    ${getFontStyle('p03Regular')}
    color: ${colors.primary65};
`

export const ImpersonationChip = styled.span`
    ${getFontStyle('p03Medium')}
    background: #eef2ff;
    border: 1px solid #c7d2fe;
    color: #3730a3;
    padding: 2px 6px;
    border-radius: 4px;
    margin-left: 8px;
    font-size: 11px;
`

export const MenuItemsList = styled.div`
    padding: 8px 0;
`

export const MenuItem = styled.button<{ $showDivider?: boolean }>`
    width: 100%;
    padding: 8px 16px;
    display: flex;
    align-items: center;
    gap: 12px;
    background: transparent;
    border: none;
    cursor: pointer;
    text-align: left;
    transition: background-color 0.2s ease;
    ${getFontStyle('p02Regular')}
    color: ${colors.primary90};

    &:hover:not(:disabled) {
        background-color: ${colors.primaryGray1};
    }

    &:focus {
        outline: none;
        background-color: ${colors.primaryGray1};
    }

    &:disabled {
        cursor: not-allowed;
        opacity: 0.6;
    }

    ${(props) =>
        props.$showDivider &&
        `
    border-top: 1px solid ${colors.primaryGray1};
    margin-top: 8px;
    padding-top: 16px;
  `}
`

export const MenuIcon = styled.span`
    width: 20px;
    height: 20px;
    color: ${colors.primary65};
    display: flex;
    align-items: center;
    justify-content: center;
`
